var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-window',_vm._g({ref:"window",staticClass:"fwindow-width-3",attrs:{"title":_vm.title}},_vm.$listeners),[_c('wallet-listbox',{attrs:{"wallets":_vm.wallets},on:{"wallet-pick":_vm.onWalletPick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }